
import STT from "./STT";
import Messages from "./Messages";
import ChatAreaFooter from "./ChatAreaFooter";
import ihtabLogo from "./images/ihtab.png"
import lexuzLogo from "./images/lex_uz.png"

function ChatArea({ messages, setMessages, chatbotSocket, setTyping, typing }){
   
    return (
        <div className="chat-area">
          {/* <div className="chat-area-header">
              <img className="logo lexuz" src={lexuzLogo}/>
              <img className="logo ihtab" src={ihtabLogo}/>
          </div> */}
          <Messages 
          typing={typing}
          setTyping={setTyping}
            messages={messages} 
            setMessages={setMessages} 
            chatbotSocket={chatbotSocket} />
          <ChatAreaFooter setTyping={setTyping} chatbotSocket={chatbotSocket} setMessages={setMessages} />
          <STT setTyping={setTyping} chatbotSocket={chatbotSocket} setMessages={setMessages}/>
       </div>
    );
}

export default ChatArea;